import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const propertyFormWidgets = makeDynamicConfigWidgets([
  {
    name: 'propertyForm',
    cols: 12,
  },
  {
    name: 'propertyConditionQualityForm',
    cols: 12,
    props: { hideInV3: true },
  },
  {
    name: 'dossierDelete',
    cols: 12,
  },
]);
